import axios from 'axios'
const { VUE_APP_API_URL } = process.env

const loadPDIHtml = async (name, bookno) => {
  try {
    const res = await axios
      .post(`${VUE_APP_API_URL}/api/pushnotification/allpdiemail/`, { name, bookno })
    if (res && res.data) {
      return res.data.length>1 ? res.data.reverse() : res.data
    }
  } catch (err) {
    return null
  }
}

export {
  loadPDIHtml
}
